export const environment = {
  production: false,
  extension: false,
  service_url: 'https://srvc.pdfmagnet.com/',
  path: {
    pdf: 'api/convert/formats/',
    convert: 'api/convert/',
  }
};